import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Form from 'vform'
import { arrayWrap } from '../utility/arrayUtitlity'
import moment from 'moment'

const FILLABEL = ['id', 'name', 'expired', 'code', 'type', 'discount', 'createdAt']

export const TYPE_USER = 0
export const TYPE_ALL = 1

export default class Coupon {
    constructor(data = null) {
        this.originalData = data

        this.id = 0
        this.name = ''
        this.expired = ''
        this.code = ''
        this.type = 0
        this.discount = null
        this.createdAt = ''

        this.form = new Form()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'Coupon'
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                this[key] = x.value
                return x
            })
            .toArray()
    }

    get data() {
        return this.originalData
    }

    get hasError() {
        return Object.keys(this.form.errors.errors).length
    }

    get errors() {
        return linq
            .from(this.form.errors.errors)
            .select((x) => {
                return arrayWrap(x.value)[0]
            })
            .toArray()
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value)
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    fill() {
        this.form = new Form(this.getPostable())
    }

    async post(url) {
        this.fill()
        return await this.form.post(url)
    }

    async delete(url) {
        this.fill()
        return await this.form.delete(url)
    }

    async patch(url) {
        this.fill()
        return await this.form.patch(url)
    }

    displayTargetAudience() {
        switch (this.type) {
            case TYPE_USER:
                return '指定ユーザーのみ使用可能'

            case TYPE_ALL:
                return '全ユーザー使用可能'

            default:
                return
        }
    }

    get inputExpired() {
        return this.expired
    }

    set inputExpired(val) {
        this.expired = moment(val).format('YYYY-MM-DD H:m:s')
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/Coupon.js